export const Feed = {
  maxQueryFromPastMonthOffset: 12, // 현재월 포함 최근 13개월
} as const;
